// EdgesContext.js
import React from 'react';

const EdgesContext = React.createContext({
  edges: [],
  setEdges: () => {},
});

export default EdgesContext;
